/**
 * MOONOCASE page motion — boot splash, prefetch, soft AJAX grid.
 * No top progress bar (it fought with AJAX filters / square clicks).
 */
(function () {
  const BOOT_KEY = 'ac-boot-seen';
  const MIN_BOOT_MS = 520;
  const bootStarted = performance.now();
  const prefetched = new Set();

  function forceUnlock() {
    try {
      const root = document.documentElement;
      root.classList.add('ac-boot-skip', 'ac-booted');
      root.classList.remove('ac-booting', 'ac-nav-pending');
      root.style.removeProperty('overflow');
      if (document.body) {
        document.body.classList.remove(
          'menu-scroll-locked',
          'overflow-hidden',
          'overflow-hidden-tablet',
          'overflow-hidden-mobile'
        );
        document.body.style.removeProperty('top');
        document.body.style.removeProperty('position');
      }
      const boot = document.getElementById('AcBoot');
      if (boot) boot.remove();
      document.querySelectorAll('a.is-nav-pending').forEach((el) => el.classList.remove('is-nav-pending'));
      document.getElementById('AcNavProgress')?.remove();
      try {
        sessionStorage.setItem(BOOT_KEY, '1');
        sessionStorage.removeItem('ac-nav-pending');
      } catch (e) {}
    } catch (e2) {}
  }

  forceUnlock();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceUnlock, { once: true });
  }
  window.setTimeout(forceUnlock, 0);
  window.setTimeout(forceUnlock, 500);

  const reduceMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function dismissBoot() {
    forceUnlock();
  }

  function scheduleBootDismiss() {
    dismissBoot();
  }

  function isInternalHref(href, anchor) {
    if (!anchor || !(anchor instanceof HTMLAnchorElement)) return false;
    if (anchor.target && anchor.target !== '' && anchor.target !== '_self') return false;
    if (anchor.hasAttribute('download')) return false;
    if (!href || href.startsWith('#') || href.startsWith('javascript:')) return false;
    if (
      anchor.hasAttribute('data-collection-filter-url') ||
      anchor.hasAttribute('data-collection-filter-clear') ||
      anchor.closest(
        '.auracase-collections, .facets-container, facet-filters-form, .mobile-facets, .active-facets'
      )
    ) {
      return false;
    }

    let url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch (e) {
      return false;
    }
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return false;
    return true;
  }

  function isInternalNavAnchor(anchor) {
    if (!isInternalHref(anchor && anchor.getAttribute('href'), anchor)) return false;
    /* Exclude cart/search modals, but allow menu-drawer (mobile nav). */
    if (anchor.closest('cart-drawer, predictive-search, details-modal')) return false;
    return true;
  }

  function prefetchUrl(href) {
    /* Disabled — document prefetch kept Chrome’s tab spinner spinning on mobile. */
    return;
  }

  function onPointerIntent(event) {
    const anchor = event.target.closest?.('a[href]');
    if (!isInternalNavAnchor(anchor)) return;
    prefetchUrl(anchor.href);
  }

  /** Soft product-grid swap for Dawn facets (sort / non-path filters). */
  window.acSoftGridSwap = function acSoftGridSwap(mutate) {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid || reduceMotion()) {
      mutate();
      return Promise.resolve();
    }

    // Clear loading dim before swap so we don't stack opacity hits
    grid.querySelector('.collection.loading')?.classList.remove('loading');
    grid.classList.remove('ac-grid-fading', 'ac-grid-enter');

    mutate();

    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        grid.classList.add('ac-grid-enter');
        window.setTimeout(() => {
          grid.classList.remove('ac-grid-enter');
          resolve();
        }, 420);
      });
    });
  };

  scheduleBootDismiss();

  document.addEventListener('pointerenter', onPointerIntent, true);
  document.addEventListener('focusin', onPointerIntent, true);
  /* pointerdown prefetch — earlier than click, no pending UI that freezes hover */
  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.button !== 0) return;
      const anchor = event.target.closest?.('a[href]');
      if (!isInternalNavAnchor(anchor)) return;
      prefetchUrl(anchor.href);
    },
    true
  );

  const warmNav = () => {
    document.querySelectorAll('.header a[href], #menu-drawer a[href]').forEach((a) => {
      if (isInternalNavAnchor(a)) prefetchUrl(a.href);
    });
  };

  /* Defer nav prefetch so hero video / first paint win the network */
  const scheduleWarmNav = () => {
    const start = () => {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(warmNav, { timeout: 4000 });
      } else {
        warmNav();
      }
    };
    window.setTimeout(start, 1800);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleWarmNav, { once: true });
  } else {
    scheduleWarmNav();
  }

  // Clear any leftover progress DOM / session flag from older builds
  try {
    sessionStorage.removeItem('ac-nav-pending');
  } catch (e) {}
  document.documentElement.classList.remove('ac-nav-pending');
  document.querySelectorAll('a.is-nav-pending').forEach((el) => el.classList.remove('is-nav-pending'));
  document.getElementById('AcNavProgress')?.remove();
})();
